import React, { useState, useEffect } from 'react';
import { useAuth } from '../fetches/AuthorizationFetch';
import '../css/LoginPage.css';
import '../css/RegistrationPage.css';

// SVG icons as constants
const BACK_ARROW_SVG = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.6891 12.1611L6.56454 7.99463L10.6891 3.82819C11.1036 3.4094 11.1036 2.73289 10.6891 2.31409C10.2745 1.8953 9.60478 1.8953 9.19021 2.31409L4.31093 7.24295C3.89636 7.66175 3.89636 8.33826 4.31093 8.75705L9.19021 13.6859C9.60478 14.1047 10.2745 14.1047 10.6891 13.6859C11.093 13.2671 11.1036 12.5799 10.6891 12.1611Z" fill="#A3AED0"/>
</svg>
`;

const OPEN_EYE_SVG = `
<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_16256_69339)">
<path d="M10.0026 5.91667C13.1609 5.91667 15.9776 7.69167 17.3526 10.5C15.9776 13.3083 13.1693 15.0833 10.0026 15.0833C6.83594 15.0833 4.0276 13.3083 2.6526 10.5C4.0276 7.69167 6.84427 5.91667 10.0026 5.91667ZM10.0026 4.25C5.83594 4.25 2.2776 6.84167 0.835938 10.5C2.2776 14.1583 5.83594 16.75 10.0026 16.75C14.1693 16.75 17.7276 14.1583 19.1693 10.5C17.7276 6.84167 14.1693 4.25 10.0026 4.25ZM10.0026 8.41667C11.1526 8.41667 12.0859 9.35 12.0859 10.5C12.0859 11.65 11.1526 12.5833 10.0026 12.5833C8.8526 12.5833 7.91927 11.65 7.91927 10.5C7.91927 9.35 8.8526 8.41667 10.0026 8.41667ZM10.0026 6.75C7.93594 6.75 6.2526 8.43333 6.2526 10.5C6.2526 12.5667 7.93594 14.25 10.0026 14.25C12.0693 14.25 13.7526 12.5667 13.7526 10.5C13.7526 8.43333 12.0693 6.75 10.0026 6.75Z" fill="#A3AED0"/>
</g>
<defs>
<clipPath id="clip0_16256_69339">
<rect width="20" height="20" fill="white" transform="translate(0 0.5)"/>
</clipPath>
</defs>
</svg>
`;

// For closed eye, we're creating a modified version of the open eye SVG
const CLOSED_EYE_SVG = `
<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_16256_69339)">
<path d="M10.0026 5.91667C13.1609 5.91667 15.9776 7.69167 17.3526 10.5C15.9776 13.3083 13.1693 15.0833 10.0026 15.0833C6.83594 15.0833 4.0276 13.3083 2.6526 10.5C4.0276 7.69167 6.84427 5.91667 10.0026 5.91667ZM10.0026 4.25C5.83594 4.25 2.2776 6.84167 0.835938 10.5C2.2776 14.1583 5.83594 16.75 10.0026 16.75C14.1693 16.75 17.7276 14.1583 19.1693 10.5C17.7276 6.84167 14.1693 4.25 10.0026 4.25ZM10.0026 8.41667C11.1526 8.41667 12.0859 9.35 12.0859 10.5C12.0859 11.65 11.1526 12.5833 10.0026 12.5833C8.8526 12.5833 7.91927 11.65 7.91927 10.5C7.91927 9.35 8.8526 8.41667 10.0026 8.41667ZM10.0026 6.75C7.93594 6.75 6.2526 8.43333 6.2526 10.5C6.2526 12.5667 7.93594 14.25 10.0026 14.25C12.0693 14.25 13.7526 12.5667 13.7526 10.5C13.7526 8.43333 12.0693 6.75 10.0026 6.75Z" fill="#A3AED0"/>
<line x1="3" y1="18" x2="17" y2="4" stroke="#A3AED0" stroke-width="2" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_16256_69339">
<rect width="20" height="20" fill="white" transform="translate(0 0.5)"/>
</clipPath>
</defs>
</svg>
`;

const SUMISNI_LOGO_SVG = `
<svg width="436" height="78" viewBox="0 0 436 78" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.3387 53.4829C24.6665 60.8152 30.3802 65.1284 39.6915 65.1284C47.3098 65.1284 53.2352 62.6483 53.2352 56.1786C53.2352 50.4637 50.2725 47.9837 37.4695 44.8566C19.2702 40.4357 13.0274 33.7503 13.0274 21.6735C13.0274 9.27325 24.4549 0 38.5276 0C52.3887 0 61.9116 6.46971 65.615 17.0369L53.4468 22.1048C51.3306 16.1743 45.7227 12.6159 38.845 12.6159C31.3325 12.6159 26.7827 15.5273 26.7827 21.8892C26.7827 27.0649 29.5337 29.3293 41.4903 32.025C59.3722 36.2304 66.9905 42.8079 66.9905 55.1003C66.9905 68.5789 55.4572 77.7443 39.7973 77.7443C25.1955 77.7443 14.2971 70.6276 10.5938 58.9822L22.3387 53.4829Z" fill="white"/>
<path d="M77.2599 47.3367V1.18611H91.0152V47.3367C91.0152 59.09 96.6231 64.5892 108.051 64.5892C119.266 64.5892 124.98 58.9822 124.98 47.3367V1.18611H138.736V47.3367C138.736 65.6675 126.673 77.7443 108.051 77.7443C88.7932 77.7443 77.2599 66.0988 77.2599 47.3367Z" fill="white"/>
<path d="M167.174 76.666H153.631V1.18611H168.762L190.453 37.5243L212.038 1.18611H226.64V76.666H212.99V23.7223L191.722 59.5213H188.548L167.174 23.5066V76.666Z" fill="white"/>
<path d="M242.404 1.18611H256.159V76.666H242.404V1.18611Z" fill="white"/>
<path d="M278.081 53.4829C280.409 60.8152 286.122 65.1284 295.434 65.1284C303.052 65.1284 308.977 62.6483 308.977 56.1786C308.977 50.4637 306.015 47.9837 293.212 44.8566C275.012 40.4357 268.769 33.7503 268.769 21.6735C268.769 9.27325 280.197 0 294.27 0C308.131 0 317.654 6.46971 321.357 17.0369L309.189 22.1048C307.073 16.1743 301.465 12.6159 294.587 12.6159C287.075 12.6159 282.525 15.5273 282.525 21.8892C282.525 27.0649 285.276 29.3293 297.232 32.025C315.114 36.2304 322.733 42.8079 322.733 55.1003C322.733 68.5789 311.199 77.7443 295.539 77.7443C280.938 77.7443 270.039 70.6276 266.336 58.9822L278.081 53.4829Z" fill="white"/>
<path d="M347.896 76.666H334.458V1.18611H347.579L381.756 52.6203V1.18611H395.299V76.666H382.179L347.896 25.124V76.666Z" fill="white"/>
<path d="M411.038 1.18611H424.794V76.666H411.038V1.18611Z" fill="white"/>
</svg>
`;

const CHECKBOX_SVG = `
<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="0.5" width="24" height="24" rx="4" fill="#4318FF"/>
<g clip-path="url(#clip0_15660_123460)">
<path d="M18 8.75L9.75 17L6 13.25" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_15660_123460">
<rect width="18" height="18" fill="white" transform="translate(3 3.5)"/>
</clipPath>
</defs>
</svg>
`;

const RegistrationPage = () => {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonActive, setIsButtonActive] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(0);
  
  // Use the authentication hook
  const { register } = useAuth();
  
  // Check if all fields have values to activate the button
  useEffect(() => {
    if (email.trim() && username.trim() && password.trim() && confirmPassword.trim()) {
      setIsButtonActive(true);
    } else {
      setIsButtonActive(false);
    }
  }, [email, username, password, confirmPassword]);
  
  // Calculate password strength
  useEffect(() => {
    if (!password) {
      setPasswordStrength(0);
      return;
    }
    
    let strength = 0;
    
    // Length check
    if (password.length >= 8) strength += 1;
    
    // Complexity checks
    if (/[A-Z]/.test(password)) strength += 1; // Has uppercase
    if (/[a-z]/.test(password)) strength += 1; // Has lowercase
    if (/[0-9]/.test(password)) strength += 1; // Has number
    if (/[^A-Za-z0-9]/.test(password)) strength += 1; // Has special char
    
    setPasswordStrength(strength);
  }, [password]);
  
  // Get password strength color
  const getPasswordStrengthColor = () => {
    switch (passwordStrength) {
      case 0:
      case 1:
        return '#FF5858'; // Red for very weak
      case 2:
        return '#FFBF1C'; // Yellow for weak
      case 3:
        return '#FFBF1C'; // Yellow for medium
      case 4:
        return '#75D854'; // Light green for strong
      case 5:
        return '#41B92C'; // Dark green for very strong
      default:
        return '#E0E5F2'; // Default gray
    }
  };
  
  // Handle form submission
  const handleSignUp = async (e) => {
    e.preventDefault();
    
    // Reset error state
    setError('');
    
    // Validate inputs
    if (!email.trim()) {
      setError('Email is required');
      return;
    }
    
    if (!username.trim()) {
      setError('Username is required');
      return;
    }
    
    if (!password.trim()) {
      setError('Password is required');
      return;
    }
    
    if (!confirmPassword.trim()) {
      setError('Password confirmation is required');
      return;
    }
    
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    
    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }
    
    // Password strength validation
    if (passwordStrength < 3) {
      setError('Please use a stronger password with at least 8 characters, including uppercase, lowercase, numbers, and special characters');
      return;
    }
    
    try {
      setIsLoading(true);
      
      const response = await fetch('https://backend-sumisni.ota-technology.com/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          username,
          password
        })
      });
      
      if (!response.ok) {
        throw new Error(`Server returned ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      console.log('Registration successful:', data);
      
      // Show success message before redirect
      setError('');
      alert('Registration successful! Redirecting to login page...');
      
      // Redirect to login page after successful registration with a slight delay
      setTimeout(() => {
        window.location.href = '/login';
      }, 1500);
      
    } catch (error) {
      console.error('Registration failed:', error);
      setError('Failed to register. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };
  
  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  
  // Toggle confirm password visibility
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  
  // Handle learn more button click
  const handleLearnMoreClick = () => {
    window.location.href = "https://sumisni.com";
  };
  
  // Handle back to login
  const handleBackToLogin = () => {
    window.location.href = "/login";
  };
  
  // Render password strength indicator
  const renderPasswordStrengthIndicator = () => {
    const strengthBars = [];
    const strengthLabels = ["Very Weak", "Weak", "Medium", "Strong", "Very Strong"];
    
    for (let i = 0; i < 5; i++) {
      if (i < passwordStrength) {
        strengthBars.push(
          <svg key={i} width="29" height="7" viewBox="0 0 29 7" fill="none" xmlns="http://www.w3.org/2000/svg" className="strength-bar">
            <rect y="0.5" width="29" height="6" fill={getPasswordStrengthColor()} />
          </svg>
        );
      } else {
        strengthBars.push(
          <svg key={i} width="30" height="7" viewBox="0 0 30 7" fill="none" xmlns="http://www.w3.org/2000/svg" className="strength-bar">
            <rect x="0.367188" y="0.5" width="29" height="6" fill="#E0E5F2"/>
          </svg>
        );
      }
    }
    
    return (
      <div className="password-strength-container">
        <div className="password-strength-label">
          <span>Password Strength:</span>
          <span className="strength-text" style={{ color: getPasswordStrengthColor() }}>
            {password ? strengthLabels[Math.min(passwordStrength, 4)] : ""}
          </span>
        </div>
        <div className="password-strength-bars">
          {strengthBars}
        </div>
      </div>
    );
  };
  
  const renderMainContent = () => {
    return (
      <div className="login-container">
        <div className="login-content-wrapper">
          <div className="login-left-section">
            <div className="login-form-container">
              <div className="back-to-landing" onClick={() => window.location.href = "/"}>
                <span 
                  className="back-icon" 
                  dangerouslySetInnerHTML={{ __html: BACK_ARROW_SVG }}
                />
                <span className="back-text">Back to landing page</span>
              </div>
              <h1 className="sign-in-title">Create Account</h1>
              <p className="sign-in-subtitle">Please input your information to register for the SUMISNI platform.</p>
              
              {error && (
                <div className="error-message">{error}</div>
              )}
              
              <form className="input-group" onSubmit={handleSignUp}>
                <div className="form-field">
                  <label className="form-label">Email *</label>
                  <input
                    className="form-input"
                    type="email"
                    placeholder="username@mail.com"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                </div>
                
                <div className="form-field">
                  <label className="form-label">Username *</label>
                  <input
                    className="form-input"
                    type="text"
                    placeholder="Choose a username"
                    value={username}
                    onChange={(event) => setUsername(event.target.value)}
                  />
                </div>
                
                <div className="form-field">
                  <label className="form-label">Password *</label>
                  <div className="password-input-container">
                    <input
                      className="form-input password-input"
                      type={showPassword ? "text" : "password"}
                      placeholder="Min. 8 characters"
                      value={password}
                      onChange={(event) => setPassword(event.target.value)}
                    />
                    <span 
                      className="password-toggle" 
                      onClick={togglePasswordVisibility}
                      dangerouslySetInnerHTML={{ __html: showPassword ? CLOSED_EYE_SVG : OPEN_EYE_SVG }}
                    />
                  </div>
                  {renderPasswordStrengthIndicator()}
                </div>
                
                <div className="form-field">
                  <label className="form-label">Confirm Password *</label>
                  <div className="password-input-container">
                    <input
                      className="form-input password-input"
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Confirm your password"
                      value={confirmPassword}
                      onChange={(event) => setConfirmPassword(event.target.value)}
                    />
                    <span 
                      className="password-toggle" 
                      onClick={toggleConfirmPasswordVisibility}
                      dangerouslySetInnerHTML={{ __html: showConfirmPassword ? CLOSED_EYE_SVG : OPEN_EYE_SVG }}
                    />
                  </div>
                </div>
                
                <div className="login-actions">
                  <button 
                    type="submit"
                    className={`sign-in-button ${isLoading ? 'loading' : ''} ${isButtonActive ? 'active' : ''}`}
                    disabled={isLoading}
                  >
                    <span className="button-text">{isLoading ? "Registering..." : "Create Account"}</span>
                  </button>
                  <span className="create-account" onClick={handleBackToLogin}>
                    <p>Already have an account?</p>
                    <p>Sign In</p>
                  </span>
                </div>
              </form>
            </div>
            
            <div className="footer-text">
              © 2025 SUMISNI Copyright. All Rights Reserved. Designed with love by DmitriyLeo!
            </div>
          </div>
          
          <div className="login-right-section">
            <div className="right-section-content">
              <div className="right-section-image" dangerouslySetInnerHTML={{ __html: SUMISNI_LOGO_SVG }} />
              <div className="info-container">
                <button className="learn-more-button" onClick={handleLearnMoreClick}>
                  <span className="learn-text">Learn more about SUMISNI on</span>
                  <span className="website-text">sumisni.com</span>
                </button>
                <div className="terms-container-wrapper">
                  <div className="terms-container">
                    <a href="#" className="terms-text">License</a>
                    <a href="#" className="terms-text">Terms of Use</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  return (
    <div className="login-page">
      {renderMainContent()}
    </div>
  );
};

export default RegistrationPage;